import React from 'react';
import { components, NoticeProps } from 'react-select';
import styled from 'styled-components';

import { DepartureOption } from '@lt/api/dist/types/departure';

export const NoOptionsMessage = (props: NoticeProps<DepartureOption, false>) => {
  const { selectProps } = props;

  return (
    <components.NoOptionsMessage {...props}>
      <span>
        У нас нет туров из <FindValue>{selectProps.inputValue}</FindValue>
      </span>
    </components.NoOptionsMessage>
  );
};

const FindValue = styled.span`
  font-weight: bold;
`;
